
import Router from 'vue-router'


Vue.use(Router);

export default new Router({
    mode:'history',
    routes: [
        {
            path: '/',
            name: '/',
            component: resolve => require(['@/views/index'], resolve),
            redirect: '/lists',
            children: [
            
                {
                    path: 'lists',
                    name: 'lists',
                    meta:{
                        isLogin:true
                    },
                    title: '残疾人列表',
                    component: resolve => require(['@/views/lists/index'], resolve)
                },
                {
                    path: 'peple/:id',
                    name: 'peple',
                    meta:{
                        isLogin:true
                    },
                    title: '新建残疾人',
                    component: resolve => require(['@/views/peple/index'], resolve)
                },
                {
                    path: 'disability/:id',
                    name: 'disability',
                    meta:{
                        isLogin:true
                    },
                    title: '残疾人详情',
                    component: resolve => require(['@/views/peple/disability_detail'], resolve)
                }

            ]
        },
        {
            path: '/login',
            name: 'login',
            title: '登录',
            component: resolve => require(['@/views/login/index'], resolve)
        },
        {
            path: '/about/agreement',
            name: 'agreement',
            title: '用户协议',
            component: resolve => require(['@/views/about/agreement'], resolve)
        },
        {
            path: '/about/privacy',
            name: 'privacy',
            title: '隐私政策',
            component: resolve => require(['@/views/about/privacy'], resolve)
        },
        {
            path: '*',
            name: '404',
            title: '404',
            component: resolve => require(['@/components/common/Base404.vue'], resolve)
        },


    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js